/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-west-2",
    "aws_cognito_identity_pool_id": "us-west-2:5c58002c-db7f-432b-8300-b82295fbc664",
    "aws_cognito_region": "us-west-2",
    "aws_user_pools_id": "us-west-2_HTM1oQg0a",
    "aws_user_pools_web_client_id": "6qcauscillpn9097loo2nm1g05",
    "oauth": {
        "domain": "lennarportalltkai.auth.us-west-2.amazoncognito.com"
    },
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL",
        "PHONE_NUMBER"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 10,
        "passwordPolicyCharacters": [
            "REQUIRES_LOWERCASE",
            "REQUIRES_UPPERCASE",
            "REQUIRES_NUMBERS",
            "REQUIRES_SYMBOLS"
        ]
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_cloud_logic_custom": [
        {
            "name": "EncompassGateway",
            "endpoint": "https://535wt07ifk.execute-api.us-west-2.amazonaws.com/prod",
            "region": "us-west-2"
        }
    ],
    "aws_appsync_graphqlEndpoint": "https://iprqromwmfgann5c3hyupg43zm.appsync-api.us-west-2.amazonaws.com/graphql",
    "aws_appsync_region": "us-west-2",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-tzr7qqiypre5zalpsfk3jupdya",
    "aws_user_files_s3_bucket": "portal-storage165011-prod",
    "aws_user_files_s3_bucket_region": "us-west-2"
};


export default awsmobile;
